"use strict";
/* SCHEDULER */
Object.defineProperty(exports, "__esModule", { value: true });
const Scheduler = {
    /* VARIABLES */
    queue: new Set(),
    triggering: false,
    triggeringQueue: [],
    triggerId: -1,
    triggerClear: typeof clearImmediate === 'function' ? clearImmediate : clearTimeout,
    triggerSet: typeof setImmediate === 'function' ? setImmediate : setTimeout,
    /* API */
    schedule: (fn) => {
        if (fn)
            Scheduler.queue.add(fn);
        if (Scheduler.triggerId !== -1)
            return;
        if (Scheduler.triggering)
            return;
        if (!Scheduler.queue.size)
            return;
        Scheduler.triggerId = Scheduler.triggerSet.call(undefined, () => {
            Scheduler.triggerId = -1;
            Scheduler.trigger();
        }, 0);
    },
    unschedule: (fn) => {
        if (fn)
            Scheduler.queue.delete(fn);
        if (Scheduler.triggerId === -1)
            return;
        Scheduler.triggerClear.call(undefined, Scheduler.triggerId);
        Scheduler.triggerId = -1;
    },
    batch: (fn) => {
        fn();
    },
    trigger: () => {
        Scheduler.unschedule();
        if (Scheduler.triggering)
            return;
        if (!Scheduler.queue.size)
            return;
        Scheduler.triggering = true;
        Scheduler.batch(() => {
            while (Scheduler.queue.size) {
                const triggeringQueue = Array.from(Scheduler.queue);
                Scheduler.triggeringQueue = triggeringQueue;
                Scheduler.queue.clear();
                for (let i = 0, l = triggeringQueue.length; i < l; i++) {
                    triggeringQueue[i]();
                }
                Scheduler.triggeringQueue = [];
            }
        });
        Scheduler.triggering = false;
    }
};
/* EXPORT */
exports.default = Scheduler;
//# sourceMappingURL=data:application/json;base64,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